.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 1.8;
}

.title {
  font-size: 18px;
  font-weight: bold;
}

.seeMore {
  font-size: 13px;
  font-weight: 300;

  &:hover {
    text-decoration: underline;
    text-decoration-thickness: 2px;
    text-underline-offset: 7px;
  }
}

@container press-release-root (min-width: 1024px) {
  .pressReleaseRoot {
    font-size: 21px;
  }
}

@media screen and (width >= 1024px) {
  .screen {
    font-size: 21px;
  }
}
